import { Component, OnInit } from "@angular/core";
import { TransitionService, StateService } from "@uirouter/angular";
import { MenuDataService } from "../core/menu.dataservice";
import { MenuItem } from "../model/menu.item";

@Component({
    selector: "crew-breadcrumb",
    template: "{{breadcrumb}}"
})
export class Breadcrumb implements OnInit {

    public breadcrumb: string;
    private menuItems: MenuItem[];

    constructor(
        private transitionService: TransitionService,
        private stateService: StateService,
        private menuDataService: MenuDataService) {
    }

    ngOnInit() {
        this.menuDataService.getMenuItems().subscribe(menuItems => this.menuItems = menuItems);

        this.updateBreadcrumb();

        this.transitionService.onFinish({}, (_transition) => {
            this.updateBreadcrumb();
        });
    }

    private updateBreadcrumb(): void {
        var currentState = this.stateService.$current.name;
        var selectedMenu = this.getSelectedMenu(this.menuItems, currentState);

        this.breadcrumb = this.getBreadcrumbDisplayPath(selectedMenu);
    }

    private getSelectedMenu(menuItems: MenuItem[], state: string): MenuItem {

        if (!menuItems) {
            return null;
        }

        for (let menuItem of menuItems) {

            if (menuItem.uiSref == state) {
                return menuItem;
            }
            else {
                var res = this.getSelectedMenu(menuItem.childMenuItems, state);
                if (res != null) {
                    return res;
                }
                continue;
            }
        }

        return null;
    }

    private getBreadcrumbDisplayPath(menuItem: MenuItem): string {
        if (!menuItem) {
            return "";
        }
        
        let path = [];
        var tmp = menuItem;

        while (tmp != null) {
            path.unshift(tmp.title);
            tmp = tmp.parent;
        }

        return path.join(" » ");
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/shared/breadcrumb.component.ts